export enum DeviceOs {
  Ios = 'iOS',
  Android = 'Android'
}
